import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from '../../../core/services/menu.service';
import { IndexedDbService } from '../../../core/services/indexed-db.service';
import {
  ClientQuestionnaireKeynameEnum,
} from '../../../../../../../../common/src/enums/client-questionnaire/client-questionnaire-keyname.enum';
import { ClientQuestionnaireStore } from '../../stores/client-questionnaire.store';
import {
  ClientQuestionnaireModel,
} from '../../../../../../../../common/dist/angular/models/client-questionnaire.model';

@Component({
  selector: 'app-get-questionnaire',
  templateUrl: './get-questionnaire.component.html',
  styleUrls: ['./get-questionnaire.component.scss'],
  standalone: false,
})
export class GetQuestionnaireComponent implements OnInit, OnDestroy {

  questionnaireId: string;

  formKeyname: ClientQuestionnaireKeynameEnum;

  clientQuestionnaireResponse: ClientQuestionnaireModel;

  clientQuestionnaireStoreSubscription?: Subscription;
  paramsSubscription?: Subscription;

  constructor(public menuService: MenuService,
              private readonly clientQuestionnaireStore: ClientQuestionnaireStore,
              private readonly indexedDbService: IndexedDbService,
              private readonly router: Router,
              private readonly route: ActivatedRoute) {
  }

  async ngOnInit() {
    const params = this.route.snapshot.params;
    this.questionnaireId = params.formId;
    this.formKeyname = params.formKeyname;
    this.paramsSubscription = this.route.paramMap.subscribe(async params => {
      console.log('Get questionnaire params changed');
      this.questionnaireId = params.get('questionnaireId');
      this.formKeyname = params.get('formKeyname') as ClientQuestionnaireKeynameEnum;
      await this.init();
    });
  }

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  unsubscribeAll() {
    this.clientQuestionnaireStoreSubscription?.unsubscribe();
    this.paramsSubscription?.unsubscribe();
    this.clientQuestionnaireStore.stopAutoRefresh(this.questionnaireId);
  }

  async init(): Promise<void> {
    // Subscribe to the store to be notified on every update of the calculation response.
    this.clientQuestionnaireStoreSubscription = this.clientQuestionnaireStore.get(this.questionnaireId).subscribe(async clientQuestionnaireResponse => {
      if (clientQuestionnaireResponse === undefined) {
        return;
      }

      this.clientQuestionnaireResponse = clientQuestionnaireResponse;

      this.clientQuestionnaireStore.stopAutoRefresh(this.questionnaireId);
    });
  }

}
